(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:productesHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes')
    .value('permisosProductesHeaderSubmenuLinksValue',  {
      'name'     : 'productes.main',
      'addPermit'    : 'AFEGIRPRODUCTE',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'productes.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTE',
            'stateOptions' : {'reload': 'productes.main.submain'}
          },
          '1': {
            'name'         : 'DEFAULT_PRODUCTE_PERMISOS',
            'state'        : 'productes.main.submain.permisos',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTE',
            'stateOptions' : {'reload': 'productes.main.submain'}
          },
          '2': {
            'name'         : 'DEFAULT_ENTITATS',
            'state'        : 'productes.main.submain.entitats',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTE',
            'stateOptions' : {'reload': 'productes.main.submain'}
          }
      }
    });
}());
